import { Flex, Text } from '@radix-ui/themes'
import { AuthButton } from 'features/auth/components/auth-buttons'
import { WALLET_PROVIDER_ICONS } from 'features/auth/constants'
import { getSolanaConnectorProviders } from 'features/auth/utils/get-solana-connector-providers'
import type { SolanaConnectorProvider } from 'features/auth/utils/get-solana-connector-providers'
import { DataTestIDs } from 'shared/constants'
import { RadixText, XyroLoading } from 'shared/ui'

interface Props {
  isLinking: boolean
  onLink: (provider: SolanaConnectorProvider) => void
}

export const LinkWalletSection: React.FC<Props> = ({ isLinking, onLink }) => {
  const connectorProviders = getSolanaConnectorProviders()

  return (
    <Flex
      direction='column'
      gap='3'
    >
      <Text
        size='3'
        weight='bold'
      >
        Link another wallet
      </Text>
      <Text
        size='2'
        color='gray'
      >
        Switch to the account you want to link in your wallet app, connect it
        and sign the message. A wallet can belong to one XYRO account only and
        cannot be unlinked.
      </Text>

      {connectorProviders.map(provider => (
        <AuthButton
          key={provider.id}
          disabled={isLinking}
          onClick={() => onLink(provider)}
          dataTestID={DataTestIDs.buttonLinkWallet}
        >
          <XyroLoading loading={isLinking}>
            {
              WALLET_PROVIDER_ICONS[
                provider.id as keyof typeof WALLET_PROVIDER_ICONS
              ]
            }
            <RadixText>{provider.name}</RadixText>
          </XyroLoading>
        </AuthButton>
      ))}
    </Flex>
  )
}
